var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconBackArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M2 10.022v.013a.96.96 0 0 0 .297.658l.014.014 5.995 5.996c.943.943 2.357-.47 1.415-1.414L5.433 11h11.585l.133-.007C18.35 10.864 18.305 9 17.018 9H5.431l4.29-4.297c.942-.943-.473-2.357-1.415-1.413L2.31 9.293l-.01.011-.053.058.063-.069a.98.98 0 0 0-.31.672z"
})));
export default SvgIconBackArrow;